import React from "react";
import { Link } from "react-router-dom";
import feather_icon from "../assets/images/gags/Feather_Icon.png";
import megaphone_icon from "../assets/images/gags/Megaphone_Icon.png";
import lipstick_icon from "../assets/images/gags/Lipstick_Icon.png";
import bamboo_cane_icon from "../assets/images/gags/Bamboo_Cane_Icon.png";
import pixie_dust_icon from "../assets/images/gags/Pixie_Dust_Icon.png";
import juggling_cubes_icon from "../assets/images/gags/Juggling_Cubes_Icon.png";
import high_dive_icon from "../assets/images/gags/High_Dive_Icon.png";
import banana_peel_icon from "../assets/images/gags/Banana_Peel_Icon.png";
import rake_icon from "../assets/images/gags/Rake_Icon.png";
import marbles_icon from "../assets/images/gags/Marbles_Icon.png";
import quicksand_icon from "../assets/images/gags/Quicksand_Icon.png";
import trapdoor_icon from "../assets/images/gags/Trapdoor_Icon.png";
import tnt_icon from "../assets/images/gags/TNT_Icon.png";
import railroad_icon from "../assets/images/gags/Railroad_Icon.png";
import one_bill_icon from "../assets/images/gags/1_Bill_Icon.png";
import small_magnet_icon from "../assets/images/gags/Small_Magnet_Icon.png";
import five_bill_icon from "../assets/images/gags/5_Bill_Icon.png";
import big_magnet_icon from "../assets/images/gags/Big_Magnet_Icon.png";
import ten_bill_icon from "../assets/images/gags/10_Bill_Icon.png";
import hypno_goggles_icon from "../assets/images/gags/Hypno-goggles_Icon.png";
import presentation_icon from "../assets/images/gags/Presentation_Icon.png";
import bike_horn_icon from "../assets/images/gags/Bike_Horn_Icon.png";
import whistle_icon from "../assets/images/gags/Whistle_Icon.png";
import bugle_icon from "../assets/images/gags/Bugle_Icon.png";
import aoogah_icon from "../assets/images/gags/Aoogah_Icon.png";
import elephant_trunk_icon from "../assets/images/gags/Elephant_Trunk_Icon.png";
import foghorn_icon from "../assets/images/gags/Foghorn_Icon.png";
import opera_singer_icon from "../assets/images/gags/Opera_Singer_Icon.png";
import cupcake_icon from "../assets/images/gags/Cupcake_Icon.png";
import fruit_pie_slice_icon from "../assets/images/gags/Fruit_Pie_Slice_Icon.png";
import cream_pie_slice_icon from "../assets/images/gags/Cream_Pie_Slice_Icon.png";
import whole_fruit_pie_icon from "../assets/images/gags/Whole_Fruit_Pie_Icon.png";
import whole_cream_pie_icon from "../assets/images/gags/Whole_Cream_Pie_Icon.png";
import birthday_cake_icon from "../assets/images/gags/Birthday_Cake_Icon.png";
import wedding_cake_icon from "../assets/images/gags/Wedding_Cake_Icon.png";
import squirting_flower_icon from "../assets/images/gags/Squirting_Flower_Icon.png";
import glass_of_water_icon from "../assets/images/gags/Glass_of_Water_Icon.png";
import squirt_gun_icon from "../assets/images/gags/Squirt_Gun_Icon.png";
import seltzer_bottle_icon from "../assets/images/gags/Seltzer_Bottle_Icon.png";
import fire_hose_icon from "../assets/images/gags/Fire_Hose_Icon.png";
import storm_cloud_icon from "../assets/images/gags/Storm_Cloud_Icon.png";
import geyser_icon from "../assets/images/gags/Geyser_Icon.png";
import flower_pot_icon from "../assets/images/gags/Flower_Pot_Icon.png";
import sandbag_icon from "../assets/images/gags/Sandbag_Icon.png";
import anvil_icon from "../assets/images/gags/Anvil_Icon.png";
import big_weight_icon from "../assets/images/gags/Big_Weight_Icon.png";
import safe_icon from "../assets/images/gags/Safe_Icon.png";
import grand_piano_icon from "../assets/images/gags/Grand_Piano_Icon.png";
import toontanic_icon from "../assets/images/gags/Toontanic_Icon.png";
import gag_shop from "../assets/images/gag_shop.png";
import PanelNavigation from "../components/PanelNavigation";

class Gags extends React.Component {
    render() {
        const panelNavigationLinks = [
            { href: "#gags", text: "Gag Levels & Tracks" },
            { href: "#buy", text: "Where to Buy Gags" },
            { href: "#damage", text: "Damage" }
        ];

        return (
            <div className="panel">
                <div className="panel-content">
                    <h1>Gags</h1>
                    <p>
                        Gags, gags, gags! What are gags? Gags are jokes and pranks
                        used by toons to help them defeat cogs. They are essentially
                        a toon's weapon arsenal, except less dangerous sounding. Toons
                        will start the game with a Cupcake and a Squirting Flower.
                        To earn new gags, toons must earn experience points and
                        complete toontasks.
                    </p>
                    <PanelNavigation links={panelNavigationLinks} adSlot="8689384557" />
                    <span className="anchor" id="gags"></span>
                    <h2>Gag Tracks &amp; Levels</h2>
                    <p>
                        There are currently seven total gag tracks with seven earnable gags in each track. There
                        are unique qualities and benefits to each gag track that make them useful in battle.
                        The assortment of gags tracks each toon has plays a huge role into gameplay strategy.
                    </p>
                    <h3>Gag Types</h3>
                    <h4>Toon-up</h4>
                    <div className="gag-row">
                        <img alt="Feather Icon" src={feather_icon} />
                        <img alt="Megaphone Icon" src={megaphone_icon} />
                        <img alt="Lipstick Icon" src={lipstick_icon} />
                        <img alt="Bamboo Cane Icon" src={bamboo_cane_icon} />
                        <img alt="Pixie Dust Icon" src={pixie_dust_icon} />
                        <img alt="Juggling Cubes Icon" src={juggling_cubes_icon} />
                        <img alt="High Dive Icon" src={high_dive_icon} />
                    </div>
                    <p>
                        Toon-up gags restore laff points by a certain amount for toons in a battle.
                        A toon cannot use Toon-up on themself. If a multi-toon Toon-up gag is used,
                        its value will be distributed evenly amongst the available toons.
                        Toon-up has medium accuracy and heals others. It does not miss, but rather
                        provides 20% of its total value if "missed".
                        These gags are the first set of gags used in battle.
                    </p>
                    <h4>Trap</h4>
                    <div className="gag-row">
                        <img alt="Banana Peel Icon" src={banana_peel_icon} />
                        <img alt="Rake Icon" src={rake_icon} />
                        <img alt="Marbles Icon" src={marbles_icon} />
                        <img alt="Quicksand Icon" src={quicksand_icon} />
                        <img alt="Trapdoor Icon" src={trapdoor_icon} />
                        <img alt="TNT Icon" src={tnt_icon} />
                        <img alt="Railroad Icon" src={railroad_icon} />
                    </div>
                    <p>
                        Trap gags are exactly what they sound like. A trap! These gags require the
                        use of Lure to activate the attack. A single cog will fall onto the trap if
                        lured successfully. Note, the level seven Train gag will damage all cogs.
                        Trap gags have perfect accuracy, given a successful lure. These gags cannot be
                        used on a cog that is already lured. Trap is the most powerful gag track and are
                        the second set of gags used in battle.
                    </p>
                    <h4>Lure</h4>
                    <div className="gag-row">
                        <img alt="$1 Bill Icon" src={one_bill_icon} />
                        <img alt="Small Magnet Icon" src={small_magnet_icon} />
                        <img alt="$5 Bill" src={five_bill_icon} />
                        <img alt="Big Magnet Icon" src={big_magnet_icon} />
                        <img alt="$10 Bill Icon" src={ten_bill_icon} />
                        <img alt="Hypno-goggles Icon" src={hypno_goggles_icon} />
                        <img alt="Presentation Icon" src={presentation_icon} />
                    </div>
                    <p>
                        Lure gags stun cogs and prevent them attacking for a certain amount of battle
                        rounds. Single cog or "all cogs" lure gags can be used.
                        Lure gags have low accuracy but have a huge gain. It prevents toons from losing
                        additional laff points in a battle and increases damage bonus for Throw and Squirt gags.
                        These gags are the third set of gags used in battle.
                    </p>
                    <h4>Sound</h4>
                    <div className="gag-row">
                        <img alt="Bike Horn Icon" src={bike_horn_icon} />
                        <img alt="Whistle Icon" src={whistle_icon} />
                        <img alt="Bugle Icon" src={bugle_icon} />
                        <img alt="Aoogah Icon" src={aoogah_icon} />
                        <img alt="Elephant Trunk Icon" src={elephant_trunk_icon} />
                        <img alt="Foghorn Icon" src={foghorn_icon} />
                        <img alt="Opera Singer Icon" src={opera_singer_icon} />
                    </div>
                    <p>
                        Sound gags are noisy gags that hit all cogs in a battle at once. When used with
                        others toon, these gags can deal a lot of damage.
                        Sound gags have high accuracy. This is the most common gag track used and highly
                        sought after when forming groups. Sound gags hit multiple cogs at once but will push
                        back lured cogs. These gags are the fourth set of gags used in battle.
                    </p>
                    <h4>Throw</h4>
                    <div className="gag-row">
                        <img alt="Cupcake Icon" src={cupcake_icon} />
                        <img alt="Fruit Pie Slice Icon" src={fruit_pie_slice_icon} />
                        <img alt="Cream Pie Slice Icon" src={cream_pie_slice_icon} />
                        <img alt="Whole Fruit Pie Icon" src={whole_fruit_pie_icon} />
                        <img alt="Whole Cream Pie Icon" src={whole_cream_pie_icon} />
                        <img alt="Birthday Cake Icon" src={birthday_cake_icon} />
                        <img alt="Wedding Cake Icon" src={wedding_cake_icon} />
                    </div>
                    <p>
                        Throw gags are one of two gag tracks that all toon have and start with. These gags
                        hit a single cog. Note, the level seven Wedding Cake gag will damage all cogs.
                        Throw gags have medium accuracy and deal a higher amount of damage than Squirt gags.
                        These gags are the fifth set of gags used in battle.
                    </p>
                    <h4>Squirt</h4>
                    <div className="gag-row">
                        <img alt="Squirting Flower Icon" src={squirting_flower_icon} />
                        <img alt="Glass of Water Icon" src={glass_of_water_icon} />
                        <img alt="Squirt Gun Icon" src={squirt_gun_icon} />
                        <img alt="Seltzer Bottle Icon" src={seltzer_bottle_icon} />
                        <img alt="Fire Hose Icon" src={fire_hose_icon} />
                        <img alt="Storm Cloud Icon" src={storm_cloud_icon} />
                        <img alt="Geyser Icon" src={geyser_icon} />
                    </div>
                    <p>
                        Squirt gags are the other gag track that all toons have and start with. These gags
                        hit a single cog. Note, the level seven Geyser gag will damage all cogs.
                        Squirt gags have high accuracy but deal a lower amount of damage than Throw.
                        These gags are the sixth set of gags used in battle.
                    </p>
                    <h4>Drop</h4>
                    <div className="gag-row">
                        <img alt="Flower Pot Icon" src={flower_pot_icon} />
                        <img alt="Sandbag Icon" src={sandbag_icon} />
                        <img alt="Anvil Icon" src={anvil_icon} />
                        <img alt="Big Weight Icon" src={big_weight_icon} />
                        <img alt="Safe Icon" src={safe_icon} />
                        <img alt="Grand Piano Icon" src={grand_piano_icon} />
                        <img alt="Toontanic Icon" src={toontanic_icon} />
                    </div>
                    <p>
                        Drop gags, well, drop a heavy object on top of cogs. These gags target a single cog.
                        Note, the level seven Toontanic gag will damage all cogs.
                        Drop gags have low accuracy, the lowest of all the gag tracks. However, they are
                        the second most powerful gag after Trap. These gags are the seventh set of gags used
                        in battle.
                    </p>
                    <h3>Gag Logistics</h3>
                    <p>
                        Toons will start out with Throw and Squirt. When completing toontasks through
                        each neighborhood, toons can pick up to four gag tracks, meaning they will
                        go without one track. They will end up with six total gags tracks. So choose wisely!
                    </p>
                    <p>
                        The <Link to="/neighborhoods">neighborhoods</Link> page details which gags
                        tracks can be earned in each neighborhood and how, but as a quick reference:
                    </p>
                    <ul>
                        <li><strong>Toontown Central</strong>: Toon-up or Sound</li>
                        <li><strong>Donald's Dock</strong>: Lure or Drop</li>
                        <li><strong>Minnie's Melodyland</strong>: Trap or Toon-up/Sound</li>
                        <ul>
                            <li>This is dependent on what was chosen in Toontown Central</li>
                        </ul>
                        <li><strong>The Brrrgh</strong>: one of the two remaining gag tracks a toon does not have</li>
                    </ul>
                    <p>
                        Once a new gag track is earned, a toon will start out with the level one gag in
                        that track. Just like how all toons start out with the level one throw and squirt
                        gags. To level up, toons can use any gag in battle to earn experience points. Something
                        to be aware of, a gag can only earn experience points on a cog if said cog is the same or
                        higher level than the gag being used. For example, a level five cog will reward experience
                        points to a level four gag. Each gag in a track will have an experience point thresholds
                        to reach in order to earn the next level gag in the track.
                    </p>
                    <h4>Required Experience Points</h4>
                    <table className="required-skill-points">
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Toon-Up</strong>
                                </td>
                                <td>
                                    <img alt="Feather Icon" src={feather_icon} /><br />0
                                </td>
                                <td>
                                    <img alt="Megaphone Icon" src={megaphone_icon} /><br />20
                                </td>
                                <td>
                                    <img alt="Lipstick Icon" src={lipstick_icon} /><br />200
                                </td>
                                <td>
                                    <img alt="Bamboo Cane Icon" src={bamboo_cane_icon} /><br />800
                                </td>
                                <td>
                                    <img alt="Pixie Dust Icon" src={pixie_dust_icon} /><br />2000
                                </td>
                                <td>
                                    <img alt="Juggling Cubes Icon" src={juggling_cubes_icon} /><br />6000
                                </td>
                                <td>
                                    <img alt="High Dive Icon" src={high_dive_icon} /><br />10000
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Trap</strong>
                                </td>
                                <td>
                                    <img alt="Banana Peel Icon" src={banana_peel_icon} /><br />0
                                </td>
                                <td>
                                    <img alt="Rake Icon" src={rake_icon} /><br />20
                                </td>
                                <td>
                                    <img alt="Marbles Icon" src={marbles_icon} /><br />100
                                </td>
                                <td>
                                    <img alt="Quicksand Icon" src={quicksand_icon} /><br />800
                                </td>
                                <td>
                                    <img alt="Trapdoor Icon" src={trapdoor_icon} /><br />2000
                                </td>
                                <td>
                                    <img alt="TNT Icon" src={tnt_icon} /><br />6000
                                </td>
                                <td>
                                    <img alt="Railroad Icon" src={railroad_icon} /><br />10000
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Lure</strong>
                                </td>
                                <td>
                                    <img alt="$1 Bill Icon" src={one_bill_icon} /><br />0
                                </td>
                                <td>
                                    <img alt="Small Magnet Icon" src={small_magnet_icon} /><br />20
                                </td>
                                <td>
                                    <img alt="$5 Bill" src={five_bill_icon} /><br />100
                                </td>
                                <td>
                                    <img alt="Big Magnet Icon" src={big_magnet_icon} /><br />800
                                </td>
                                <td>
                                    <img alt="$10 Bill Icon" src={ten_bill_icon} /><br />2000
                                </td>
                                <td>
                                    <img alt="Hypno-goggles Icon" src={hypno_goggles_icon} /><br />6000
                                </td>
                                <td>
                                    <img alt="Presentation Icon" src={presentation_icon} /><br />10000
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Sound</strong>
                                </td>
                                <td>
                                    <img alt="Bike Horn Icon" src={bike_horn_icon} /><br />0
                                </td>
                                <td>
                                    <img alt="Whistle Icon" src={whistle_icon} /><br />40
                                </td>
                                <td>
                                    <img alt="Bugle Icon" src={bugle_icon} /><br />200
                                </td>
                                <td>
                                    <img alt="Aoogah Icon" src={aoogah_icon} /><br />1000
                                </td>
                                <td>
                                    <img alt="Elephant Trunk Icon" src={elephant_trunk_icon} /><br />2500
                                </td>
                                <td>
                                    <img alt="Foghorn Icon" src={foghorn_icon} /><br />7500
                                </td>
                                <td>
                                    <img alt="Opera Singer Icon" src={opera_singer_icon} /><br />10000
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Throw</strong>
                                </td>
                                <td>
                                    <img alt="Cupcake Icon" src={cupcake_icon} /><br />0
                                </td>
                                <td>
                                    <img alt="Fruit Pie Slice Icon" src={fruit_pie_slice_icon} /><br />10
                                </td>
                                <td>
                                    <img alt="Cream Pie Slice Icon" src={cream_pie_slice_icon} /><br />50
                                </td>
                                <td>
                                    <img alt="Whole Fruit Pie Icon" src={whole_fruit_pie_icon} /><br />400
                                </td>
                                <td>
                                    <img alt="Whole Cream Pie Icon" src={whole_cream_pie_icon} /><br />2000
                                </td>
                                <td>
                                    <img alt="Birthday Cake Icon" src={birthday_cake_icon} /><br />6000
                                </td>
                                <td>
                                    <img alt="Wedding Cake Icon" src={wedding_cake_icon} /><br />10000
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Squirt</strong>
                                </td>
                                <td>
                                    <img alt="Squirting Flower Icon" src={squirting_flower_icon} /><br />0
                                </td>
                                <td>
                                    <img alt="Glass of Water Icon" src={glass_of_water_icon} /><br />10
                                </td>
                                <td>
                                    <img alt="Squirt Gun Icon" src={squirt_gun_icon} /><br />50
                                </td>
                                <td>
                                    <img alt="Seltzer Bottle Icon" src={seltzer_bottle_icon} /><br />400
                                </td>
                                <td>
                                    <img alt="Fire Hose Icon" src={fire_hose_icon} /><br />2000
                                </td>
                                <td>
                                    <img alt="Storm Cloud Icon" src={storm_cloud_icon} /><br />6000
                                </td>
                                <td>
                                    <img alt="Geyser Icon" src={geyser_icon} /><br />10000
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Drop</strong>
                                </td>
                                <td>
                                    <img alt="Flower Pot Icon" src={flower_pot_icon} /><br />0
                                </td>
                                <td>
                                    <img alt="Sandbag Icon" src={sandbag_icon} /><br />20
                                </td>
                                <td>
                                    <img alt="Anvil Icon" src={anvil_icon} /><br />100
                                </td>
                                <td>
                                    <img alt="Big Weight Icon" src={big_weight_icon} /><br />500
                                </td>
                                <td>
                                    <img alt="Safe Icon" src={safe_icon} /><br />2000
                                </td>
                                <td>
                                    <img alt="Grand Piano Icon" src={grand_piano_icon} /><br />6000
                                </td>
                                <td>
                                    <img alt="Toontanic Icon" src={toontanic_icon} /><br />10000
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                        A quick tip, as noted in <Link to="/toontips#4">Toon Tips</Link>, there are ways to
                        multiply gag experience points. These methods include fighting in cog invasions, battling
                        in cog headquarters, and defeating tall cog buildings. Another tip, combining cog invasions
                        with cog buildings makes for an even greater multiplier.
                    </p>
                    <span className="anchor" id="buy"></span>
                    <h2>Where to Buy Gags</h2>
                    <p>
                        Toons can purchase gags at Goofy's Gag Shop. Goofy's
                        Gag Shop can be found in every playground, except for Chip N' Dales Acorn Acres
                        and Goofy's Speedway. All gags, with the exception level seven gags, can be purchased at the
                        gag shop with a single jellybean each. Gags can also be purchased at the end of
                        every trolley game.
                    </p>
                    <img
                        className="content-img"
                        style={{ height: 350 + "px" }}
                        src={gag_shop}
                        alt="Goofy's Gag Shop in TTC"
                    />
                    <h3>Gag Pouches</h3>
                    <p>
                        Toons carry their gags in a gag pouch. This pouch limits a toon on how many gags they can buy
                        and carry at any given time. The size of the gag pouch can be upgraded through
                        toontasks in the main campaign.
                    </p>
                    <ul>
                        <li>Small pouch capacity: 20 gags</li>
                        <li>Medium pouch capacity: 25 gags</li>
                        <li>Large pouch capacity: 30 gags</li>
                        <li>Small bag capacity: 35 gags</li>
                        <li>Medium bag capacity: 40 gags</li>
                        <li>Large bag capacity: 50 gags</li>
                        <li>Small backpack capacity: 60 gags</li>
                        <li>Medium backpack capacity: 70 gags</li>
                        <li>Large backpack capacity: 80 gags</li>
                    </ul>
                    <h3>How To Stock Level Seven Gags</h3>
                    <p>
                        You might be wondering, how do I restock a level seven gag? The answer is simple.
                        Experience points! Confused still? No problem. Even after earning 10000 experience points
                        and maxing a gag track, a toon will have to earn 500 experience points every time they would
                        like to restock a level seven gag. If a given level seven gag is in a toons gag pouch and
                        500 experience points have been earned, the points will remain at 0 and will restock the
                        gag immediately after use.
                    </p>
                    <span className="anchor" id="damage"></span>
                    <h2>Damage</h2>
                    <p>
                        All gags deal a certain amount of damage to cogs, except for Toon-up and Lure gags.
                        Gags range from a minimum to a maximum amount of damage dealt. Minimum damage
                        dealt is when the gag is new and no additional experience points have been earned.
                        Maximum damage dealt is when all experience points required have been earned and the
                        next gag is unlocked. Everything in between is called training. Toons will train their
                        gags to improve damage dealt and get closer to the next gag in a track.
                    </p>
                    <p>
                        Level one to level five for Drop gags and all level seven gags have the same minimum and
                        maximum damage dealt.
                    </p>
                    <br />
                    <br />
                    <PanelNavigation links={panelNavigationLinks} adSlot="1733984228" />
                </div>
            </div>
        );
    }
}

export default Gags;
